import React from 'react';
import { motion } from 'framer-motion';

export const NoirBackground = () => (
  <>
    <div className="noir-vignette" />
    <div className="film-grain" />
  </>
);

export const GameCard = ({ children, className = '', ...props }) => (
  <div className={`bg-gradient-to-b from-[#161616] to-[#111] border border-[#222] rounded-lg p-6 select-none ${className}`} {...props}>
    {children}
  </div>
);

export const Button = ({
  children, color = 'red', className = '', disabled = false, onClick,
  'data-testid': testId, ...props
}) => {
  const styles = {
    red: 'bg-gradient-to-r from-[#DC2626] to-[#B91C1C] text-[#E0DDD5]',
    white: 'bg-gradient-to-r from-[#E8E5DD] to-[#D5D2CA] text-[#0A0A0A]',
    dark: 'bg-gradient-to-b from-[#1E1E1E] to-[#141414] border border-[#333] text-[#888]',
    bright: 'bg-gradient-to-r from-[#EF4444] to-[#DC2626] text-white',
  };
  return (
    <motion.button data-testid={testId} onClick={disabled ? undefined : onClick}
      className={`btn-noir w-full py-4 rounded-lg font-typewriter text-lg uppercase tracking-wider select-none ${
        styles[color] || styles.red
      } ${disabled ? 'opacity-25 cursor-not-allowed' : 'cursor-pointer'} ${className}`}
      whileTap={disabled ? {} : { scale: 0.98 }} {...props}>
      {children}
    </motion.button>
  );
};

export const Pill = ({ children, color = 'red', className = '' }) => {
  const styles = {
    red: 'text-[#EF4444] border border-[#DC2626]/40 bg-gradient-to-r from-[#DC2626]/15 to-[#DC2626]/5',
    white: 'text-[#E0DDD5] border border-[#333] bg-gradient-to-r from-white/8 to-white/3',
    dark: 'text-[#666] border border-[#222] bg-gradient-to-r from-[#161616] to-[#111]',
  };
  return (
    <span className={`inline-block px-4 py-1 rounded font-mono text-xs uppercase tracking-wider ${
      styles[color] || styles.red
    } ${className}`}>{children}</span>
  );
};

export const CounterButton = ({ onDecrease, onIncrease, value, label, dotColor }) => (
  <div className="bg-gradient-to-b from-[#161616] to-[#111] border border-[#222] rounded-lg p-5 flex items-center justify-between">
    <div className="flex items-center gap-3">
      <div className="w-2.5 h-2.5 rounded-full" style={{ background: dotColor }} />
      <span className="text-[#E0DDD5] font-bold text-sm uppercase tracking-wider">{label}</span>
    </div>
    <div className="flex items-center gap-3">
      <button onClick={onDecrease}
        className="btn-noir w-9 h-9 bg-gradient-to-b from-[#1E1E1E] to-[#141414] border border-[#333] rounded flex items-center justify-center text-[#888] font-bold">-</button>
      <span className="font-typewriter text-3xl text-[#EF4444] w-8 text-center">{value}</span>
      <button onClick={onIncrease}
        className="btn-noir w-9 h-9 bg-gradient-to-b from-[#1E1E1E] to-[#141414] border border-[#333] rounded flex items-center justify-center text-[#888] font-bold">+</button>
    </div>
  </div>
);
